export const CREATE_DRAFT = gql`
  mutation CreateDraft($workspaceId: String!, $input: UpdateDraftInput!) {
    createDraft(workspaceId: $workspaceId, input: $input) {
      id
      email {
        subject
        to
        cc
        bcc
      }
    }
  }
`

export const UPDATE_DRAFT = gql`
  mutation UpdateDraft($workspaceId: String!, $input: UpdateDraftInput!) {
    updateDraft(workspaceId: $workspaceId, input: $input) {
      id
    }
  }
`
